import ReactDOM from "react-dom"
import React from "react"
import "./index.css";
import App from "./App"
// Dummy function to simulate fetching project name

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
